import { makeRequest } from '@services/requests/makeRequest';
import { OPT_IN_RETENTION } from '@services/requests/requestResources';

export const getOptInRetentionCrmList = () =>
  makeRequest('GET', `${OPT_IN_RETENTION}/get-crms`);

export const importOptInRetention = payload =>
  makeRequest('POST', `${OPT_IN_RETENTION}`, payload);
